import { render } from "./bulkForm.vue?vue&type=template&id=66803daa"
import script from "./bulkForm.vue?vue&type=script&lang=js"
export * from "./bulkForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__